// 上报 分发 结果反馈 不予受理
import $http from '../../utils/http';
let complaintPath = '/tio/complain/qywx/';

// 上报 指挥中心
export const aOperation = data => {
    return $http({
        url: complaintPath + 'accept/operation',
        data,
        method: 'POST'
    });
};

// 上报 类型、企业、部门
export const dOperation = data => {
    return $http({
        url: complaintPath + 'dispose/operation',
        data,
        method: 'POST'
    });
};
export default {
    aOperation,
    dOperation
}
